import type { useRouter } from 'next/navigation'

// Neither the router type nor PrefetchKind is a public export of Next — derive both from the
// public `useRouter` instead of reaching into next/dist internals.
type AppRouter = ReturnType<typeof useRouter>
type PrefetchKind = NonNullable<Parameters<AppRouter['prefetch']>[1]>['kind']

/**
 * Prefetches a route's WHOLE RSC payload, not just its loading shell.
 *
 * Every /trade/* route is dynamic (the dashboard layout reads the auth cookie), and a plain
 * `router.prefetch()` of a dynamic route only fetches up to its nearest loading.tsx. A click then
 * swaps in the skeleton and still waits on a full server round trip before the page shows. A full
 * prefetch caches the finished payload (and starts loading its client chunks), so the click
 * commits straight from the router cache. Safe here: these pages are static client shells whose
 * data all flows through React Query / WebSockets, so a cached payload is never stale data.
 *
 * Full prefetches live for the router's static stale time (5 min); calling this again is deduped
 * while the entry is fresh, so it's cheap to re-call on hover/focus to keep a link warm.
 */
export function prefetchFullRoute(router: AppRouter, href: string) {
  router.prefetch(href, { kind: 'full' as PrefetchKind })
}
